import { render, staticRenderFns } from "./ForwardRegistersConfiguration.vue?vue&type=template&id=092abbfe"
import script from "./ForwardRegistersConfiguration.vue?vue&type=script&lang=js"
export * from "./ForwardRegistersConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ForwardRegistersConfiguration.vue?vue&type=style&index=0&id=092abbfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports